import {FormattedMessage} from 'react-intl';

const UpdateDetail = ({label, children}) => {
  return (
    <div className='pr4'>
      <div className='h5 jumbo mb1'><FormattedMessage id={label}/></div>
      <div className='h4'>{children}</div>
    </div>
  );
};

export default UpdateDetail;
